<template>
  <sds-input-control :label="label">
    <v-text-field
      outlined
      dense
      hide-details
      :aria-label="label"
      v-bind="$attrs"
      v-on="$listeners"
      :required="required"
      :rules="rules"
    />
  </sds-input-control>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
  label: {
    type: String,
    default: '',
  },
  required: {
    type: Boolean,
    default: false,
  },
  requiredLabel: {
    type: String,
    default: 'O campo é obrigatório',
  },
});

const rules = computed(() => {
  return props.required ? [(v: string) => !!v || props.requiredLabel] : [];
});
</script>
